export default __webpack_public_path__ + "static/media/calendar-previous.ad839794.svg";